module.exports = __webpack_public_path__ + "img/canvas-bg6.d6176192.png";